<template>
  <div class="columns is-multiline">
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <!-- <a @click="goTo('content')" class="button is-light is-radiusless">&lt; Back</a> -->
          <a @click="toggleInstructions()" class="button is-dark is-radiusless">Ayuda</a>
        </div>
        <form class="has-text-left">
          <div class="card-content">
            <h3 class="is-size-3">{{initTitle}}</h3>
            <br>
            <div class="columns is-multiline">
              <b-field label="Archivo*" class="column is-12">
                <!-- <b-upload v-model="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"> -->
                <b-upload v-model="file">
                  <a class="button is-warning is-radiusless">
                    <span>Clic para buscar</span>
                  </a>
                </b-upload>
                <span class="file-name" v-if="file">
                  {{ file.name }}
                </span>
              </b-field>
            </div>
          </div>
          <div class="card-footer">
            <button type="button" class="button is-warning is-radiusless" @click="submit()">Enviar</button>
          </div>
        </form>
      </div>
    </section>

    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Archivos cargados</h3>
          <b-table :data="table.data" :striped="true" :hoverable="true" :paginated="true" :per-page="8">
            <template slot-scope="props">
              <b-table-column field="narchivo" label="Nombre archivo" style="width: 50px;" sortable>
                  {{ props.row.archive_name }}
              </b-table-column>
              <b-table-column field="rango" label="Fecha subida" sortable>
                  {{ props.row.initial_date }} to {{ props.row.final_date }}
              </b-table-column>
              <b-table-column field="nombre" label="Nombre fundación" sortable>
                  {{ props.row.nit }} {{ props.row.name }}
              </b-table-column>
              <!-- <b-table-column field="retencion" label="Retencion" sortable>
                  {{ props.row.rete }}
              </b-table-column> -->
              <b-table-column field="totalbase" label="Valor Total Base" sortable>
                  {{ props.row.base }}
              </b-table-column>
              <b-table-column field="totalrete" label="Valor Total Retención" sortable>
                  {{ props.row.retentation }}
              </b-table-column>
              <b-table-column field="actions" label="Acciones" sortable>
                <a class="button is-danger is-radiusless" @click="deletea(props.row.id)">
                  <font-awesome-icon :icon="['fa','times']"/></a>
                <a class="button is-success is-radiusless" @click="generateExcel(props.row.archive_name)">
                  <font-awesome-icon :icon="['fa','file-excel']"/></a>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <!-- help -->
    <section v-if="needHelp" class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="toggleInstructions()" class="button is-light is-radiusless">X Cerrar ayuda</a>
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Ayuda</h3>
          <p class="is-size-6">
            Una <b>Entrada</b> es un espacio para importar la información de retención de un excel.
          </p>
          <hr>
          <h3 class="is-size-4">Instrucciones</h3>
          <ul>
              <li>- Campos con (*) son requeridos</li>
              <li>- La extensión disponible para archivos es (xlsx)</li>
            </ul>
        </div>
      </div>
    </section>
    <!-- modal -->
    <b-modal
      :active.sync="isCardModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <form action="">
        <div class="modal-card" id="modal-error-educational" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Error, ¿Quieres continuar?</p>
          </header>
          <section class="modal-card-body">
            <div style="text-align:center;">
              <table border="2" id="toUpload">
                <thead>
                  <tr>
                    <td style="text-align:center;"># Posición</td>
                    <td style="text-align:center;">Error</td>
                    <td style="text-align:center;">Identificación Responsable Financiero</td>
                    <td style="text-align:center;">Nombre Responsable Financiero</td>
                  </tr>
                </thead>
                <tbody v-for="(err, index) in errors" :key="index">
                  <td style="text-align:center;">{{ err.position }}</td>
                  <td style="text-align:center;">{{ err.error }}</td>
                  <td style="text-align:center; vertical-align:middle; padding: 0.5em;">
                    <b-field
                      :type="(err.requiredI) ? 'is-danger' : ''"
                      :message="(err.requiredN) ? 'Completa este campo' : ''"
                    >
                      <b-input v-model="err.identificationAcu" :required="err.nameAcu !== ''" minlength="5" @input="err.requiredI = false"></b-input>
                    </b-field>
                  </td>
                  <td style="text-align:center; vertical-align:middle; padding: 0.5em;">
                    <b-field
                      :type="(err.requiredN) ? 'is-danger' : ''"
                      :message="(err.requiredN) ? 'Completa este campo' : ''"
                    >
                      <b-input v-model="err.nameAcu" :required="err.identificationAcu !== ''" @input="err.requiredN = false"></b-input>
                    </b-field>
                  </td>
                </tbody>
              </table>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button
                label="No"
                @click="isCardModalActive = false" />
            <b-button
                label="Si"
                type="is-success"
                @click="validateFormErrors()" />
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import VueCkeditor from 'vue-ckeditor2'
import env from '@/env'
import ArchivesService from '@/services/ArchivesService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'input-students',
  mixins: [xMisc, sGate],
  components: {
    VueCkeditor
  },
  data () {
    return {
      isLoading: false,
      file: null,
      needHelp: false,
      helpText: 'Ayuda',
      initTitle: 'Subir archivo Estudiantes',
      table: {
        data: []
      },
      isCardModalActive: false,
      errors: []
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    modalErrors (errores) {
      errores = JSON.parse(errores)
      this.errors = []
      for (let index = 0; index < errores.length; index++) {
        errores[index].requiredI = false
        errores[index].requiredN = false
      }
      this.errors = errores
      this.isCardModalActive = true
    },
    validateFormErrors () {
      var hasError = false
      for (let index = 0; index < this.errors.length; index++) {
        if (this.errors[index].identificationAcu !== '' && this.errors[index].identificationAcu.length < 5) {
          this.errors[index].requiredI = true
          hasError = true
        }
        if (this.errors[index].identificationAcu !== '' && this.errors[index].nameAcu === '') {
          this.errors[index].requiredN = true
          hasError = true
        }
        if (this.errors[index].nameAcu !== '' && this.errors[index].identificationAcu === '') {
          this.errors[index].requiredI = true
          hasError = true
        }
      }

      if (hasError) {
        return false
      }

      const changes = {}
      for (let index = 0; index < this.errors.length; index++) {
        if (this.errors[index].identificationAcu !== '' && this.errors[index].nameAcu !== '') {
          this.errors[index].requiredI = true
          changes[this.errors[index].identification + '-' + this.errors[index].oc] = {
            'identificationAcu': this.errors[index].identificationAcu,
            'nameAcu': this.errors[index].nameAcu
          }
        }
      }

      let formData = new FormData()
      formData.append('file', this.file)
      formData.append('changes', JSON.stringify(changes))
      this.isCardModalActive = false
      this.save(formData)
    },
    async fetchData () {
      var archives = await ArchivesService.fetchArchivesEstudents(this.$session.get('user').token)
      for (var i = 0; i < archives.data.length; i++) {
        this.table.data.push(archives.data[i])
      }
    },
    async submit () {
      try {
        if (this.file == null) {
          this.alert('danger', 'Error, Debe Cargar un archivo')
        } else {
          this.openLoading()
          let formData = new FormData()
          formData.append('file', this.file)
          var response = await ArchivesService.validateFilesEducational(formData, this.$session.get('user').token)
          this.openLoading()
          if (response.data.success === true) {
            this.closeLoading()
            this.save(formData)
          } else {
            this.closeLoading()
            var responsedata = response.data
            if (Object.keys(responsedata).includes('error') && responsedata.data === 'error') {
              this.confirmCustom2('El archivo ya se encuentra en la base de datos')
            } else if (Object.keys(responsedata).includes('error_file')) {
              // for (let index = 0; index < responsedata.error_file.length; index++) {
              //   // this.alert('danger', responsedata.error_file[index])
              // }
              this.confirmCustom2('El archivo presenta los siguientes errores:\n' + responsedata.error_file.join('.\n'))
            } else {
              const dataErrores = JSON.parse(responsedata.data)
              if (dataErrores.length > 0 && Object.keys(dataErrores[0]).includes('position')) {
                this.modalErrors(responsedata.data)
              } else {
                this.confirmCustom2('El archivo tiene registros sin datos de estudiantes en las posiciones ' + dataErrores.join(', '))
              }
              // position
              // this.confirmCustom(errores, formData)
            }
          }
        }
      } catch (error) {
        console.log(error)
        this.closeLoading()
      }
    },
    async deleteData (id) {
      try {
        this.openLoading()
        var response = await ArchivesService.delArchive({id: id}, this.$session.get('user').token)
        if (response.data.success) {
          this.$toast.open({
            message: 'Archivo eliminado',
            type: 'is-success'
          })
          // unset data
          var s = this.table.data.length
          for (var i = s - 1; i >= 0; i--) {
            if (this.table.data[i].id === id) {
              this.table.data.splice(i, 1)
            }
          }
        } else {
          this.alert('danger', 'Error, Intente nuevamente')
        }
        this.closeLoading()
      } catch (error) {
        console.log(error)
        this.closeLoading()
      }
    },
    deletea (id) {
      this.$dialog.confirm({
        title: 'Eliminando archivo',
        message: 'Estas seguro que quieres <b>eliminar</b> este archivo?',
        confirmText: 'Eliminar archivo',
        cancelText: 'Cancelar',
        type: 'is-danger',
        onConfirm: () => this.deleteData(id)
      })
    },
    toggleInstructions () {
      if (this.needHelp) {
        this.needHelp = false
        this.helpText = 'Ayuda'
      } else {
        this.needHelp = true
        this.helpText = 'Cerrar ayuda'
      }
    },
    async save (formData) {
      this.openLoading()
      var response = await ArchivesService.uploadFilesEducational(formData, this.$session.get('user').token)
      if (response.data.success) {
        this.file = null
        this.$toast.open({
          message: 'Información guardada correctamente',
          type: 'is-success'
        })
        this.table.data = []
        this.fetchData()
      }
      this.closeLoading()
    },
    openLoading () {
      this.isLoading = true
    },
    closeLoading () {
      this.isLoading = false
    },
    async confirmCustom (errores, formData) {
      this.$dialog.confirm({
        title: 'Error, ¿Quieres continuar?',
        message: errores,
        cancelText: 'No',
        confirmText: 'Si',
        type: 'is-success',
        onConfirm: () => {
          this.save(formData)
        }
      })
    },
    confirmCustom2 (message) {
      this.$dialog.alert({
        title: 'Error',
        message: message,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times',
        iconPack: 'fa'
      })
    },
    async generateExcel (archive) {
      window.open(env.API_BASE_URL + '/outputs-educational/EXCEL/null/null/null/null' + '/' + archive + '/null', '_blank')
    }
  }
}
</script>
<style>
  #modal-error-educational .is-danger {
    background: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/input/InputStudents.vue